/*
  Monta as seções "Carregar ao rolar a página" (ec-slider-collection com a
  opção ec_sob_demanda ligada).

  Na página a seção sai só com o título e um espaço reservado
  ([data-ec-sob-demanda]). Quando ela chega a 800 px da tela, a seção pronta é
  buscada pela Section Rendering API (?section_id=) e entra no lugar do
  conteúdo de #shopify-section-<id>.

  Para não deixar ninguém esperando ao rolar, o HTML já é baixado (sem montar)
  na primeira interação ou 8 s depois do load, pelo ecDepoisDaCarga do
  theme.liquid. Baixar não pesa na thread principal; montar, sim, por isso
  montar fica para quando a seção está perto de aparecer.

  O IntersectionObserver não avisa de uma seção que pulou de "abaixo da tela"
  para "acima da tela" sem passar por ela (volta para a página já rolada,
  barra de rolagem arrastada, link para o rodapé). Por isso, quando o HTML
  pré-baixado chega, a seção que já ficou acima da tela é montada também; a
  ancoragem de rolagem do navegador segura o que está na tela.

  Se a busca falhar, a seção fica vazia e tenta de novo na próxima vez que
  chegar perto da tela.
*/
(function () {
  if (window.ecSecaoSobDemanda) return;
  window.ecSecaoSobDemanda = true;

  var SELETOR = '[data-ec-sob-demanda]';
  var pedidos = {};

  function buscar(id) {
    if (!pedidos[id]) {
      var url = window.location.pathname + '?section_id=' + encodeURIComponent(id);
      pedidos[id] = fetch(url, { credentials: 'same-origin' }).then(function (resposta) {
        if (!resposta.ok) throw new Error('HTTP ' + resposta.status);
        return resposta.text();
      });
      pedidos[id].catch(function () {
        delete pedidos[id];
      });
    }
    return pedidos[id];
  }

  // <script> que chega por innerHTML não roda: recria cada um.
  function ativarScripts(raiz) {
    raiz.querySelectorAll('script').forEach(function (antigo) {
      var novo = document.createElement('script');
      Array.prototype.forEach.call(antigo.attributes, function (atributo) {
        novo.setAttribute(atributo.name, atributo.value);
      });
      novo.textContent = antigo.textContent;
      antigo.replaceWith(novo);
    });
  }

  // ec-slider-collection.js procura as seções uma vez só, na carga. As que
  // entram depois são iniciadas aqui; a trava data-ec-initialized evita
  // iniciar duas vezes se as duas coisas acontecerem juntas.
  function iniciarCarrossel(raiz) {
    if (!window.EcSliderCollection || !customElements.get('slider-component')) return;
    raiz.querySelectorAll('[data-ec-slider-collection]:not([data-ec-initialized])').forEach(function (secao) {
      secao.setAttribute('data-ec-initialized', 'true');
      new window.EcSliderCollection(secao.dataset.ecSliderCollection);
    });
  }

  function montar(marcador) {
    if (marcador.dataset.ecSobDemandaEstado) return;
    marcador.dataset.ecSobDemandaEstado = 'carregando';
    var id = marcador.dataset.ecSobDemanda;

    buscar(id)
      .then(function (html) {
        var molde = document.createElement('template');
        molde.innerHTML = html;
        var recebida = molde.content.getElementById('shopify-section-' + id);
        var destino = document.getElementById('shopify-section-' + id);
        if (!recebida || !recebida.querySelector('[data-ec-slider-collection]') || !destino) {
          throw new Error('resposta sem a seção');
        }
        destino.replaceChildren.apply(destino, Array.prototype.slice.call(recebida.childNodes));
        ativarScripts(destino);
        iniciarCarrossel(destino);
      })
      .catch(function (erro) {
        delete marcador.dataset.ecSobDemandaEstado;
        console.error('[ec-secao-sob-demanda]', id, erro);
        if (observador) observador.observe(marcador);
      });
  }

  var observador = null;

  function iniciar() {
    var marcadores = document.querySelectorAll(SELETOR);
    if (!marcadores.length) return;

    if (!('IntersectionObserver' in window)) {
      marcadores.forEach(montar);
      return;
    }

    observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          observador.unobserve(entrada.target);
          montar(entrada.target);
        });
      },
      { rootMargin: '0px 0px 800px 0px' }
    );
    marcadores.forEach(function (marcador) {
      observador.observe(marcador);
    });

    if (window.ecDepoisDaCarga) {
      window.ecDepoisDaCarga(function () {
        document.querySelectorAll(SELETOR).forEach(function (marcador) {
          buscar(marcador.dataset.ecSobDemanda).then(function () {
            if (marcador.isConnected && marcador.getBoundingClientRect().bottom < 0) {
              observador.unobserve(marcador);
              montar(marcador);
            }
          }, function () {});
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar, { once: true });
  } else {
    iniciar();
  }
})();
